import gql from 'graphql-tag';

// Query used to get the list of modules linked to the current dataname.
export const restaurant = gql`
	query restaurant {
		restaurant {
			id
			companyName
			modules {
				id
				name
				identifier
				enabled
				visibility
			}
		}
	}
`;
